import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiMail } from "react-icons/fi";
import siteConfig from "../config/siteConfig";

export function formatAddress(address = siteConfig.contact?.address) {
  if (!address) return "";
  if (typeof address === "string") return address;
  if (Array.isArray(address)) return address.filter(Boolean).join(", ");

  const street = [address.line1, address.line2].filter(Boolean).join(", ");
  const postalCity = [address.postalCode, address.city]
    .filter(Boolean)
    .join(" ");

  return [street, address.district, postalCity, address.region, address.country]
    .filter(Boolean)
    .join(", ");
}

export function ContentHero({
  eyebrow,
  title,
  description,
  children,
  aside,
  compact = false,
}) {
  return (
    <header className={`content-hero${compact ? " content-hero--compact" : ""}`}>
      <div className="content-shell content-hero__grid">
        <div className="content-hero__copy">
          {eyebrow ? <p className="content-eyebrow">{eyebrow}</p> : null}
          <h1>{title}</h1>
          {description ? <p className="content-hero__lede">{description}</p> : null}
          {children ? <div className="content-hero__actions">{children}</div> : null}
        </div>
        {aside ? <div className="content-hero__aside">{aside}</div> : null}
      </div>
    </header>
  );
}

export function SectionHeading({ eyebrow, title, description, align = "left" }) {
  return (
    <div className={`content-section-heading content-section-heading--${align}`}>
      {eyebrow ? <p className="content-eyebrow">{eyebrow}</p> : null}
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
    </div>
  );
}

export function PolicyToc({ items }) {
  return (
    <nav aria-label="On this page" className="policy-toc">
      <p>On this page</p>
      <ol>
        {items.map((item, index) => (
          <li key={item.id}>
            <a href={`#${item.id}`}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              {item.label}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}

export function ContactCta({
  eyebrow = "We are here to help",
  title = "Still have a question?",
  description = "Our pantry team is happy to help with products, orders, and everything in between.",
}) {
  const email = siteConfig.contact?.email;

  return (
    <section aria-labelledby="content-contact-title" className="content-contact-cta">
      <div>
        <p className="content-eyebrow">{eyebrow}</p>
        <h2 id="content-contact-title">{title}</h2>
        <p>{description}</p>
      </div>
      <div className="content-contact-cta__actions">
        {email ? (
          <a className="content-button content-button--light" href={`mailto:${email}`}>
            <FiMail aria-hidden="true" />
            Email our team
          </a>
        ) : (
          <Link className="content-button content-button--light" to="/contact">
            Contact us
            <FiArrowRight aria-hidden="true" />
          </Link>
        )}
      </div>
    </section>
  );
}
